module.exports = __webpack_public_path__ + "static/media/vox-logo-light.3415878d.png";